export default function WorkParagraph({ children }) {
  return <div className="col-start-1 col-span-full md:col-start-7 md:col-span-6 my-4 md:my-8">{children}</div>;
}
